import React from 'react';
import { notification } from 'antd';
import { RiCloseFill, RiCheckboxCircleFill, RiErrorWarningFill } from 'react-icons/ri';
import appColors from '../const/colors';

export const notificationTypes = {
  error: 'error',
  success: 'success',
  info: 'info',
  warning: 'warning',
};

const renderNotificationIcon = (type) => {
  switch (type) {
    case 'success':
      return <RiCheckboxCircleFill style={{ color: appColors.success }} />;
    case 'info':
      return <RiErrorWarningFill style={{ color: appColors.info }} />;
    case 'warning':
      return <RiErrorWarningFill style={{ color: appColors.warning }} />;
    case 'error':
      return <RiErrorWarningFill style={{ color: appColors.error }} />;

    default:
      return <RiCheckboxCircleFill style={{ color: appColors.success }} />;
  }
};

export const makeNotification = (type, message, descriptionText = '') => {
  notification.open({
    key: type,
    top: 65,
    title: message,
    description: descriptionText,
    icon: renderNotificationIcon(type),
    closeIcon: <RiCloseFill className="remix-icon da-text-color-black-80" size={24} />,
  });
};
